/**
 * @generated SignedSource<<8f7f6d0caba612f6fa4a0c79741ea289>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ManageNicknames_userprofile_data$data = {
  readonly accountGroups: ReadonlyArray<{
    readonly accounts: ReadonlyArray<{
      readonly financialAccountId: number;
      readonly id: any;
    }>;
    readonly id: string;
    readonly name: string;
  }>;
  readonly accounts: ReadonlyArray<{
    readonly accountNickname: string;
    readonly financialAccountId: number;
  }>;
  readonly id: string;
  readonly " $fragmentType": "ManageNicknames_userprofile_data";
};
export type ManageNicknames_userprofile_data$key = {
  readonly " $data"?: ManageNicknames_userprofile_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"ManageNicknames_userprofile_data">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "financialAccountId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ManageNicknames_userprofile_data",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "UserAccount",
      "kind": "LinkedField",
      "name": "accounts",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountNickname",
          "storageKey": null
        },
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AccountGroup",
      "kind": "LinkedField",
      "name": "accountGroups",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Account",
          "kind": "LinkedField",
          "name": "accounts",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserProfileViewer",
  "abstractKey": null
};
})();

(node as any).hash = "617fcb762b70fb53fe7999637b166e02";

export default node;
